<template>
  <nav class="sidebar-navbar">
    <div class="sn-orb sno1"></div>
    <div class="sn-orb sno2"></div>

    <!-- Logo -->
    <div class="sn-logo">
      <div class="sn-logo-icon">
        <img :src="appIcon" alt="Lucky Friday" class="sn-logo-img" />
      </div>
      <span class="sn-logo-text">Lucky Friday</span>
    </div>

    <!-- Nav links -->
    <div class="sn-nav-links">
      <router-link
        to="/Dashboard"
        active-class="active"
        class="sn-item"
        aria-label="Route to homepage and user dashboard"
      >
        <font-awesome-icon :icon="['fas', 'house']" class="sn-icon" />
        <span class="sn-label">Dashboard</span>
      </router-link>
      <router-link
        to="/Transactions"
        active-class="active"
        class="sn-item"
        aria-label="Route to user transactions defaulting at current month"
      >
        <font-awesome-icon :icon="['fas', 'list']" class="sn-icon" />
        <span class="sn-label">Transactions</span>
      </router-link>
      <router-link
        to="/Categories"
        active-class="active"
        class="sn-item"
        aria-label="Route to user defined categories page"
      >
        <font-awesome-icon :icon="['fas', 'tag']" class="sn-icon" />
        <span class="sn-label">Categories</span>
      </router-link>
      <router-link
        to="/Budget"
        active-class="active"
        class="sn-item"
        aria-label="Route to user budget page defaulting at current month"
      >
        <font-awesome-icon
          :icon="['fas', 'file-invoice-dollar']"
          class="sn-icon"
        />
        <span class="sn-label">Budget</span>
      </router-link>
      <router-link
        to="/NetWorth"
        active-class="active"
        class="sn-item"
        aria-label="Route to net worth page for financial health overview"
      >
        <font-awesome-icon
          :icon="['fas', 'money-bill-trend-up']"
          class="sn-icon"
        />
        <span class="sn-label">Net Worth</span>
      </router-link>
      <router-link
        to="/UserAccount"
        active-class="active"
        class="sn-item"
        aria-label="Route to user page for settings and app info"
      >
        <font-awesome-icon :icon="['fas', 'user']" class="sn-icon" />
        <span class="sn-label">Account</span>
      </router-link>
    </div>
  </nav>
</template>

<script>
import appIcon from '@/assets/images/brightlogo.png';

export default {
  setup() {
    return { appIcon };
  },
};
</script>

<style scoped>
.sidebar-navbar {
  background: #004751;
  color: white;
  padding: 1.25rem 0.75rem;
  /* display: flex; */
  flex-direction: column;
  gap: 4px;
  height: 100%;
  position: relative;
  overflow: hidden;
}

/* Orbs */
.sn-orb {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.04);
  pointer-events: none;
}
.sno1 {
  width: 180px;
  height: 180px;
  top: -70px;
  right: -50px;
}
.sno2 {
  width: 120px;
  height: 120px;
  bottom: 60px;
  left: -40px;
}

/* Logo */
.sn-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 0.75rem 1.25rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 0.5rem;
  position: relative;
  z-index: 1;
}
.sn-logo-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}
.sn-logo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}
.sn-logo-text {
  font-size: 0.88rem;
  font-weight: 700;
  color: white;
  letter-spacing: -0.01em;
}

/* Nav links container */
.sn-nav-links {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  z-index: 1;
}

/* Nav items */
.sn-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0.7rem 0.75rem;
  border-radius: 12px;
  text-decoration: none;
  position: relative;
  transition: background 0.2s ease;
  overflow: hidden;
}

.sn-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 20%;
  bottom: 20%;
  width: 3px;
  background: transparent;
  border-radius: 0 3px 3px 0;
  transition: background 0.2s ease;
}

.sn-item:hover {
  background: rgba(255, 255, 255, 0.06);
}
.sn-item.active {
  background: rgba(255, 255, 255, 0.1);
}
.sn-item.active::before {
  background: linear-gradient(180deg, #7f77dd, #5dcaa5);
}

/* Icon */
.sn-icon {
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.95rem;
  width: 18px;
  text-align: center;
  flex-shrink: 0;
  transition: color 0.2s ease;
}
.sn-item:hover .sn-icon {
  color: rgba(255, 255, 255, 0.75);
}
.sn-item.active .sn-icon {
  color: #48ffcd;
}

/* Label */
.sn-label {
  font-size: 0.82rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  transition:
    color 0.2s ease,
    font-weight 0.2s ease;
}
.sn-item:hover .sn-label {
  color: rgba(255, 255, 255, 0.8);
}
.sn-item.active .sn-label {
  color: white;
  font-weight: 600;
}
</style>

<!-- <template>
  <nav class="sidebar-navbar">
    <div class="sidebar-nav-wrapper">
      <router-link
        to="/Dashboard"
        active-class="active"
        aria-label="Route to homepage and user dashboard"
        ><font-awesome-icon :icon="['fas', 'house']" />
        <span>Dashboard</span></router-link
      >
      <router-link
        to="/Transactions"
        active-class="active"
        aria-label="Route to user transactions defaulting at current month"
        ><font-awesome-icon :icon="['fas', 'list']" /><span
          >Transactions</span
        ></router-link
      >
      <router-link
        to="/Categories"
        active-class="active"
        aria-label="Route to user defined categories page"
        ><font-awesome-icon :icon="['fas', 'tag']" /><span
          >Categories</span
        ></router-link
      >
      <router-link
        to="/Budget"
        active-class="active"
        aria-label="Route to user budget page defaulting at current month"
        ><font-awesome-icon :icon="['fas', 'file-invoice-dollar']" /><span
          >Budget</span
        ></router-link
      >
      <router-link
        to="/NetWorth"
        active-class="active"
        aria-label="Route to net worth page for financial health overview"
        ><font-awesome-icon :icon="['fas', 'money-bill-trend-up']" /><span
          >Net Worth</span
        ></router-link
      >
      <router-link
        to="/UserAccount"
        active-class="active"
        aria-label="Route to user page for settings and app info"
        ><font-awesome-icon :icon="['fas', 'user']" /><span
          >User Account</span
        ></router-link
      >
    </div>
  </nav>
</template>

<style>
.sidebar-navbar {
  background: #004751;
  color: white;
  justify-content: space-around;
  padding: 1em 0;
}

.sidebar-nav-wrapper {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.sidebar-navbar ul {
  display: flex;
  flex-direction: row;
  height: 100%;
  padding: 0;
  margin: 0;
}

.sidebar-navbar li {
  flex-grow: 1;
  height: 100%;
  margin: 0;
}

.sidebar-navbar a {
  text-decoration: none;
  font-weight: bold;
  font-size: 0.8em;
  width: 100%;
  text-align: left;
}

.sidebar-navbar a i {
  margin-right: 0.5em;
  padding-bottom: 0.2em;
}

.light-theme .sidebar-navbar a {
  color: #ffffff;
  /* color: #213547; */
  /* the dark color here makes the text illegible so need to figure out why i tried that out */
}

.light-theme .sidebar-navbar .active {
  /* border-top: 2px solid #004751; */
  border-top: 2px solid #0a52d8;
}

.dark-theme .sidebar-navbar .active {
  border-top: 2px solid #4baffd;
}

@media only screen and (min-width: 900px) {
  .sidebar-navbar ul {
    display: block;
  }
}

@media screen and (min-width: 992px) {
  .sidebar-navbar a {
    padding: 1em;
    width: 80%;
  }

  .sidebar-nav-wrapper svg {
    padding-right: 10px;
  }

  .light-theme .sidebar-navbar .active {
    border-top: none;
    background: white;
    border-radius: 15px;
    color: black;
    padding: 1em;
  }
}
</style> -->
